import { Controller } from "@hotwired/stimulus"

/*
This controller implements the UI pattern where a group of radio buttons has an "other" option
that reveals a free-form text input.
To make this as simple as possible for the backend to process, the text input is used as the
actual "output" value of the whole radio group. All the radio buttons besides the "other" option
will write their value to the output field when selected, so they can be ignored by the backend.
*/
export default class extends Controller {
  static targets = ["output", "option"]

  static values = {
    // which option value should enable/show the output field
    other: { type: String, default: "other" },
  }  

  connect() {
    if (!this.hasOutputTarget)
      throw new Error("No output target found")

    let initialHidden = false;
    let otherOption = null;

    // if the output field is starting out empty, don't show it
    if (this.outputTarget.value === "")
      initialHidden = true;

    // enumerate the radio buttons
    this.optionTargets.forEach(option => {
      if (option.value == this.otherValue) {
        // this radio button is the "other" option that makes the output field visible
        otherOption = option;
      } else if (option.value === this.outputTarget.value) {
        // this radio button should be pre-selected since it matches the output value
        option.checked = true;
        initialHidden = true;
      }

      option.addEventListener("change", (e) => {
        if (e.target.value === this.otherValue) {
          // if the "other" option has been selected, show the output field
          this.outputTarget.value = "";
          this.outputTarget.classList.remove("hidden");
        } else {
          // otherwise, hide the output field
          this.outputTarget.value = e.target.value;
          this.outputTarget.classList.add("hidden");
        }
      })
    })

    if (!otherOption)
      throw new Error("No 'other' option found")    

    // pre-select the "other" option if the output field is starting out visible
    if (!initialHidden) {
      otherOption.checked = true;
    }

    // set starting visibility of the output field
    this.outputTarget.classList.toggle("hidden", initialHidden);
  }
}

